
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/webinar-by-university-delegates",
      function () {
        return require("private-next-pages/partners/webinar-by-university-delegates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/webinar-by-university-delegates"])
      });
    }
  